import { useContext, useEffect, useState } from "react"

// Context
import { UserContext } from "../../../../context/userContext"

//Google places
import AutoComplete from "react-google-autocomplete"

//PrimeReact
import { Skeleton } from "primereact/skeleton"
import { InputText } from "primereact/inputtext"

//Style
import { Button } from "primereact/button"
import "../../../../styles/RefTextInputGooglePlaces.css"
import RefHelp from "../EntitySearch/RefHelp"

export function RefGetAddressFromPlace(place) {
  let hadSelection = false
  let address = ""
  let city = ""
  let state = ""
  let zipCode = ""
  let country = ""
  let longitude = undefined
  let latitude = undefined

  if (place.address_components) {
    hadSelection = true
    place.address_components.forEach((x) => {
      if (x.types.includes("street_number")) {
        address = x.long_name
      } else if (x.types.includes("route")) {
        //Street name
        address = address + " " + x.long_name
      } else if (x.types.includes("sublocality")) {
        address = address + ", " + x.long_name
      } else if (x.types.includes("locality")) {
        //City
        city = x.long_name
      } else if (x.types.includes("administrative_area_level_2")) {
        //state/province
      } else if (x.types.includes("administrative_area_level_1")) {
        //state/province
        state = x.long_name
      } else if (x.types.includes("country")) {
        country = x.long_name
      } else if (x.types.includes("postal_code")) {
        zipCode = x.long_name
      }
    })

    if (place.geometry) {
      latitude = place.geometry.location.lat()
      longitude = place.geometry.location.lng()
    }
  }

  return {
    hadSelection,
    address,
    city,
    state,
    zipCode,
    country,
    longitude,
    latitude,
  }
}

export default function RefGoogleAutoComplete({
  label,
  disabled,
  defaultValue,
  overrideLabelWidth,
  overrideInputWidth,
  divStyle,
  isInitialLoad,
  zIndexValue,
  showHelpText,
  onPlaceSelect,
  onRefocusClicked,
}) {
  const userCtx = useContext(UserContext)

  const googlePlacesApiKey = userCtx.googlePlacesKey

  const [value, setValue] = useState({ value: undefined })

  useEffect(() => {
    if (defaultValue !== "") {
      setValue({ value: defaultValue })
    }
  }, [defaultValue])

  const getInput = () => {
    if (isInitialLoad) {
      return <Skeleton height="42px" />
    } else {
      return (
        <>
          {disabled ? (
            <InputText disabled style={{ width: "100%" }} />
          ) : (
            <div style={{ display: "flex" }}>
              <AutoComplete
                className="p-inputtext"
                style={{
                  position: "relative",
                  zIndex: zIndexValue
                    ? zIndexValue + " !important"
                    : "1501 !important",
                  width: "100%",
                  marginTop: "0px",
                }}
                apiKey={googlePlacesApiKey}
                onPlaceSelected={(place) => onPlaceSelect(place)}
                value={value.value}
                options={{
                  types: ["geocode", "establishment"],
                }}
                onChange={(event, newValue) => {
                  setValue({ value: newValue })
                }}
                onError={(error) =>
                  console.error("GoogleAutoComplate error: " + error)
                }
              />

              {onRefocusClicked ? (
                <Button
                  style={{
                    display: "inline-flex",
                    height: "40px",
                    background: "none",
                    marginLeft: "1px",
                  }}
                >
                  <img
                    src="/mapbox/mapbox-marker-icon-20px-red.png"
                    alt="Focus on location"
                    style={{ marginTop: "15px", width: "100%" }}
                    onClick={() => onRefocusClicked()}
                  />
                </Button>
              ) : null}
            </div>
          )}
        </>
      )
    }
  }

  const getLabel = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return <label>{label}</label>
    }
  }

  return (
    <div style={divStyle}>
      <div style={{ width: overrideLabelWidth }}>{getLabel()}</div>
      {showHelpText ? (
        <div>
          <RefHelp content="Enter the participant address to measure the distance to the closest Referral partner(s)." />
        </div>
      ) : null}

      <div style={{ width: overrideInputWidth }}>{getInput()}</div>
    </div>
  )
}
